<style>
  input.ng-invalid.ng-touched {
    border: 1px solid red;
  }

  .primaryEmail {
    border: 1px solid red;
  }

  .p-dropdown.ng-invalid.ng-touched:not(form)>div {
    border: 1px solid red;
  }
</style>
<p-toast position="bottom-center"></p-toast>
<section>
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 p-0">
        <div class="card">
          <div class="devcare-card-header">
            <span class="devcare-sub-header"><i class="fas fa-plus mr-1"></i>Vendor Registration</span>
                   <div class="row">      
                <div class="col-md-12">
                  <div class="">
                    <br>
                      <h5 class="text-dark text-sm"><i></i> Note:</h5>
                      <ul>
                        <li>Username must be a valid email address</li>
                        <li>Password must be 8-16 characters containing alphanumeric and symbols</li>               
                      </ul>              
                    </div>
                </div>
              </div> 
          </div>
          <div class="text-sm text-left">

          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </div>
</section>
<!-- <section>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
        class="p-button-outlined p-button-danger float-right m-2 bg-primary"></button>
      <button pButton pRipple type="button" label="Save" icon="pi pi-check"
        [disabled]="!applicantAddForm.valid || applicantEmailAvail" (click)="onApplicantSubmit(applicantAddForm)"
        class="p-button-outlined p-button-success float-right m-2 bg-success"></button>
    </div>
    <div class="col-md-1"></div>
  </div>
</section> -->
<section>
  <form [formGroup]="preregisterForm" novalidate>
    <div class="row">
      <div class="col-md-1">
      </div>
      <div class="col-md-10">        
        <p-accordion>
          <p-accordionTab header="Company Profile" [selected]="true">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="firstName">First Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="firstName"  type="text" pInputText>
                     <span class="text-danger"
                      *ngIf="(preRegisterFormControl.firstName.touched) && preRegisterFormControl.firstName.errors?.required">
                    </span> 
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="lastName">Last Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100"  formControlName="lastName" type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(preRegisterFormControl.lastName.touched) && preRegisterFormControl.lastName.errors?.required">
                    </span> 
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="adminEmailId">Admin Email Id<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="adminEmailId" type="text" pInputText>
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.adminEmailId.touched) && preRegisterFormControl.adminEmailId.errors?.required">
                  </span> 
                  <span class="text-danger"
                      *ngIf="preRegisterFormControl.adminEmailId.touched && preRegisterFormControl.adminEmailId.errors?.email">
                      Please enter a valid email address
                    </span>
                  </div>
                
                </div> 
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="vendorName">Vendor Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="vendorName" type="text" pInputText>
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.vendorName.touched) && preRegisterFormControl.vendorName.errors?.required">
                  </span> 
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="verifyVendorName">Verify Vendor Name</label>
                    <input class="form-control" maxlength="100" formControlName="verifyVendorName" type="text" pInputText>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="vendorShortName">Vendor Short Name<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="vendorShortName" type="text" pInputText>
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.vendorShortName.touched) && preRegisterFormControl.vendorShortName.errors?.required">
                  </span> 
                  </div>
                
                </div> 
                <div class="p-fluid p-formgrid p-grid">  
                  <div class="p-field p-col-12 p-md-4">
                      <label for="vendorEmailId">Vendor Email Id<span class="required-field">*</span></label>
                      <input class="form-control" maxlength="100" formControlName="vendorEmailId" type="email" pInputText>
                      <span class="text-danger"
                      *ngIf="(preRegisterFormControl.vendorEmailId.touched) && preRegisterFormControl.vendorEmailId.errors?.required">
                    </span> 
                    <span class="text-danger"
                    *ngIf="preRegisterFormControl.vendorEmailId.touched && preRegisterFormControl.vendorEmailId.errors?.email">
                    Please enter a valid email address
                  </span>
                    </div>                
                  <div class="p-field p-col-12 p-md-4">             
                    <label for="addressLine1">Address Line 1<span class="required-field">*</span></label>
                    <input class="form-control"  formControlName="addressLine1" type="text" pInputText>
                    <span class="text-danger"
                      *ngIf="(preRegisterFormControl.addressLine1.touched) && preRegisterFormControl.addressLine1.errors?.required">
                    </span> 
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="addressLine2">Address Line 2</label>
                    <input class="form-control" formControlName="addressLine1" maxlength="100"  type="text" pInputText>
                  </div>                
                
                </div> 
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="webAddress">Web Address<span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="webAddress" pInputText>  
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.webAddress.touched) && preRegisterFormControl.webAddress.errors?.required">
                  </span>                 
                  </div>  
                  <div class="p-field p-col-12 p-md-4">
                    <label for="taxIdNumber">Tax ID Number<span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="taxIdNumber" pInputText>   
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.taxIdNumber.touched) && preRegisterFormControl.taxIdNumber.errors?.required">
                  </span>                 
                  </div> 
                  <div class="p-field p-col-12 p-md-4">
                    <label for="selectedCountry">Country<span class="required-field">*</span></label>
                    <p-dropdown id="selectedCountry" [options]="countries" optionLabel="name" [disabled]=true>
                    </p-dropdown>               
                  </div> 
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="state">State<span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="state" pInputText>   
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.state.touched) && preRegisterFormControl.state.errors?.required">
                  </span>                   
                  </div>  
                  <div class="p-field p-col-12 p-md-4">
                    <label for="city">City<span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="city" pInputText>  
                    <span class="text-danger"
                    *ngIf="(preRegisterFormControl.city.touched) && preRegisterFormControl.city.errors?.required">
                  </span>                     
                  </div> 
                  <div class="p-field p-col-12 p-md-4">
                    <label for="zipCode">Zip Code</label>
                    <input type="text" class="form-control" formControlName="zipCode" pInputText>                  
                  </div> 
                </div>                               
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Company Details" [selected]="false" disabled="true">         

          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Delivery Team  Details" [selected]="false" disabled="true">
          
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Reference" [selected]="false" disabled="true">
         
          </p-accordionTab>
        </p-accordion>
        <p-accordion>
          <p-accordionTab header="Admin Details" [selected]="false" disabled="true">
           
          </p-accordionTab>
        </p-accordion>
      </div>
      <div class="col-md-1">

      </div>
    </div>
  </form>
</section>
<section>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
        class="p-button-outlined p-button-sm p-button-danger float-right m-2 bg-primary"></button>
      <button pButton pRipple type="button" label="Register" icon="pi pi-check" [disabled]="!preregisterForm.valid" (click)="onPreRegister(preregisterForm)"        
        class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"></button>
    </div>
    <div class="col-md-1"></div>
  </div>
</section>

<script>
  
</script>